export const SPECIALTY_TYPE = "specialtyType";
export const APPOINTMENT_TYPE = "appointmentType";
export const PRACTITIONER = "practitioner";
export const LOCATION = "location";
export const TIMEZONE = "timezone";
export const APPOINTMENT_DATE_TIME = "appointmentDateTime";



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/consts/stepKeys.js